import classNames from 'classnames/bind';
import styles from './DateRangePicker.module.css';
import DatePicker from 'react-datepicker';
import { formatDate } from '../../utils/date';
import { useTranslation } from 'react-i18next';

interface DateRangePicker extends Duration {
  startPicker: { min: string; max: string };
  endPicker: { min: string; max: string };
  onChange: (startDate: string, endDate: string) => void;
  descSuffix?: string;
}

interface Duration {
  startDate: string;
  endDate: string;
}

export default function DateRangePicker({
  startDate,
  endDate,
  startPicker,
  endPicker,
  onChange,
  descSuffix,
}: DateRangePicker) {
  const cx = classNames.bind(styles);
  const { i18n } = useTranslation();

  return (
    <>
      <DatePicker
        className="datepicker-input"
        onChange={(date) => {
          onChange(
            formatDate(date as Date, 1, 'ko'),
            formatDate(endDate, 1, 'ko')
          );
        }}
        selected={new Date(startDate.replaceAll('.', '-'))}
        dateFormat={i18n.language === 'ko-KR' ? 'yyyy.MM.dd' : 'MM/dd/yyyy'}
        locale={i18n.language}
        minDate={new Date(startPicker.min.replaceAll('.', '-'))}
        maxDate={new Date(startPicker.max.replaceAll('.', '-'))}
        showPopperArrow={false}
        showDisabledMonthNavigation
      />
      ~{' '}
      <DatePicker
        className="datepicker-input"
        onChange={(date) => {
          onChange(
            formatDate(startDate, 1, 'ko'),
            formatDate(date as Date, 1, 'ko')
          );
        }}
        selected={new Date(endDate.replaceAll('.', '-'))}
        dateFormat={i18n.language === 'ko-KR' ? 'yyyy.MM.dd' : 'MM/dd/yyyy'}
        locale={i18n.language}
        minDate={new Date(endPicker.min.replaceAll('.', '-'))}
        maxDate={new Date(endPicker.max.replaceAll('.', '-'))}
        showPopperArrow={false}
        showDisabledMonthNavigation
      />
      {descSuffix}
    </>
  );
}
